import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export enum CheckoutComSourceFor3DS {
  ENTER = 'enter',
  CHANGE_PAYMENT_METHOD = 'change-payment-method',
}

export const useCheckoutCom3DSPayment = () => {
  const router = useRouter();
  const [data, setData] = useState<{
    checkoutComPaymentSessionId: string | null;
    source: CheckoutComSourceFor3DS | null;
  }>({
    checkoutComPaymentSessionId: null,
    source: null,
  });

  useEffect(() => {
    if (!router.isReady) return;

    const { ckopsid = null, source = null } = router.query as Record<
      string,
      string | null
    >;

    if (!source || !ckopsid) {
      console.log(
        `Missing required query parameters (ckopsid: ${ckopsid}, source: ${source}). Redirecting to /account.`,
      );
      router.push('/account');
      return;
    }

    if (
      !(Object.values(CheckoutComSourceFor3DS) as string[]).includes(source)
    ) {
      console.log(`Unknown source (${source}). Redirecting to /account.`);
      router.push('/account');
      return;
    }

    setData({
      checkoutComPaymentSessionId: ckopsid,
      source: source as CheckoutComSourceFor3DS,
    });
  }, [router.isReady, router.query]);

  return data;
};
